import Vue from 'vue'
import Router from 'vue-router'
import index from '@/module/index/router'
import mine from '@/module/mine/router'
import store from '@/module/store/router'
import register from '@/module/register/router'
let routes = [

  ];

routes = routes.concat(
  index,
  mine,
  store,
  register,
  [
    {
      path: '*',
      redirect: '/'
    }
  ]
);

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: routes,
  // linkActiveClass: 'active'
})




// WEBPACK FOOTER //
// ./src/router/index.js